"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = void 0;
var _react = _interopRequireDefault(require("react"));
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("./");
require("./Column.scss");
const Column = _ref => {
  let {
    left,
    right,
    ratio = _.COLUMNS_RATIO.half,
    className
  } = _ref;
  const ratioClass = ratio && (0, _upperCase.upperCaseFirst)(ratio);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Column-Wrapper', {
      [`cds-Column-Wrapper--${ratioClass}`]: ratio
    }, className)
  }, left && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Column', {
      [`cds-Column--${ratioClass}`]: ratio
    }, 'cds-Column--Left')
  }, left), right && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-Column', {
      [`cds-Column--${ratioClass}`]: ratio
    }, 'cds-Column--Right')
  }, right));
};
exports.Column = Column;
//# sourceMappingURL=Column.js.map